import React from 'react';
import { Link } from 'react-router-dom';
import { APP_CONFIG } from '../../constants/appConfig';

const Footer = () => {
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <img src={APP_CONFIG.logoPath} alt={`${APP_CONFIG.appName} Logo`} className="w-9 h-9 object-contain rounded-xl" />
              <span className="text-white font-bold text-lg">{APP_CONFIG.appName}</span>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-sm">
              A B2B hotel aggregation platform that simplifies how businesses search and book accommodations. Compare vendor-wise pricing for the same property — all in one place.
            </p>
            <div className="mt-6 flex items-center gap-4">
              <a
                href={`mailto:${APP_CONFIG.contactEmail}`}
                className="text-sm text-gray-400 hover:text-blue-400 transition-colors flex items-center gap-2"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                {APP_CONFIG.contactEmail}
              </a>
            </div>
            <div className="mt-2">
              <a
                href={`tel:${APP_CONFIG.contactPhone}`}
                className="text-sm text-gray-400 hover:text-blue-400 transition-colors flex items-center gap-2"
              >
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                {APP_CONFIG.contactPhone}
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm uppercase tracking-wider">
              Quick Links
            </h4>
            <ul className="space-y-3">
              {[
                { label: 'About', action: () => scrollToSection('about') },
                { label: 'FAQ', action: () => scrollToSection('faq') },
                { label: 'Contact', action: () => scrollToSection('contact') },
              ].map((item) => (
                <li key={item.label}>
                  <button
                    onClick={item.action}
                    className="text-sm text-gray-400 hover:text-blue-400 transition-colors"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
              <li>
                <Link
                  to="/login"
                  className="text-sm text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Log In
                </Link>
              </li>
              <li>
                <Link
                  to="/register"
                  className="text-sm text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Sign Up
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-5 text-sm uppercase tracking-wider">
              Legal
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/terms-and-conditions"
                  className="text-sm text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/privacy-policy"
                  className="text-sm text-gray-400 hover:text-blue-400 transition-colors"
                >
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-500">
            {APP_CONFIG.copyrightFullText}
          </p>
          <div className="flex items-center gap-6">
            <Link
              to="/terms-and-conditions"
              className="text-xs text-gray-500 hover:text-gray-400 transition-colors"
            >
              Terms
            </Link>
            <Link
              to="/privacy-policy"
              className="text-xs text-gray-500 hover:text-gray-400 transition-colors"
            >
              Privacy
            </Link>
            <a
              href="mailto:filterhotels@gmail.com"
              className="text-xs text-gray-500 hover:text-gray-400 transition-colors"
            >
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
